import { jsxs as C, jsx as L } from "react/jsx-runtime";
const e = () => /* @__PURE__ */ C("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ L(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.4921 2.0006H7.23408L4.5079 2.00012C4.29385 2.00012 4.08857 2.08178 3.93722 2.22713L0.236387 5.78112C-0.0787957 6.0838 -0.0787957 6.57453 0.236387 6.87721L7.44192 13.7731C7.7571 14.0758 8.26811 14.0758 8.58329 13.7731L15.7636 6.87769C16.0788 6.57501 16.0788 6.08428 15.7636 5.7816L12.0628 2.22761C11.9114 2.08226 11.7061 2.0006 11.4921 2.0006ZM2.64673 4.43061L0.950571 6.05947H4.08724C4.09703 6.04322 4.10748 6.02725 4.11859 6.01158L6.49024 2.66494H5.74705L4.5079 2.66445C4.47733 2.66445 4.448 2.67612 4.42638 2.69688L2.64673 4.43061ZM6.75227 12.1713L1.07967 6.7238H4.03169C4.03964 6.74381 4.0485 6.7636 4.05825 6.78311L6.75227 12.1713ZM7.89606 12.9241L4.79598 6.7238H11.2273L8.10378 12.9244C8.06173 13.0079 7.93785 13.0077 7.89606 12.9241ZM11.9658 6.78318C11.9757 6.76365 11.9846 6.74383 11.9926 6.7238H14.9455L9.23166 12.211L11.9658 6.78318ZM11.9391 6.05947H15.0746L11.5736 2.69737C11.552 2.6766 11.5227 2.66494 11.4921 2.66494H9.56046L11.9087 6.01266C11.9194 6.02798 11.9296 6.0436 11.9391 6.05947ZM4.92143 6.05947H11.1074L8.89004 2.89826C8.86861 2.86772 8.83277 2.8494 8.79442 2.8494H7.25729C7.21913 2.8494 7.13143 2.86749 7.10996 2.89778L4.92143 6.05947Z",
      fill: "#5E63E5"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M1.07967 6.72368L6.75227 12.1712L4.05825 6.78299C4.0485 6.76348 4.03964 6.74369 4.03169 6.72368H1.07967Z",
      fill: "#B6B9F3"
    }
  ),
  /* @__PURE__ */ L(
    "path",
    {
      d: "M0.950571 6.05935L2.64673 4.43048L4.42638 2.69676C4.448 2.676 4.47733 2.66433 4.5079 2.66433L5.74705 2.66481H6.49024L4.11859 6.01146C4.10748 6.02712 4.09704 6.0431 4.08724 6.05935H0.950571Z",
      fill: "#B6B9F3"
    }
  )
] });
export {
  e as SpecialUpgradeIcon
};
//# sourceMappingURL=index.es599.js.map
